import { Modal } from "@modernatx/ui-kit-react";
import React from "react";

import { AutoPayModalContent } from "@/components/Payments/AutoPayModal/AutoPayModalContent";
import { useScheduledPaymentSetup } from "@/hooks/useScheduledPaymentSetup";
import { AutoPayTypes } from "@/types";
import { PaymentMethod } from "@/types/PaymentMethod";

export interface AutoPayModalProps {
  modalType: AutoPayTypes;
  isVisible: boolean;
  setVisible: (visible: boolean) => void;
}

const modalButtonTexts: Record<AutoPayTypes, string> = {
  [AutoPayTypes.AllInvoices]: "Set up",
  [AutoPayTypes.AllInvoicesUpdate]: "Update"
};

export const AutoPayModal: React.FC<AutoPayModalProps> = ({
  modalType,
  isVisible,
  setVisible
}) => {
  const modalBtnText = modalButtonTexts[modalType];
  const modalButtons = [
    { label: "Cancel", onClick: () => setVisible(false) },
    { label: modalBtnText, onClick: () => handleConfirmClick() }
  ];
  const {
    selectedPayment,
    setSelectedPayment,
    scheduleOption,
    setScheduleOption,
    showAddPaymentMethod,
    paymentMethods
  } = useScheduledPaymentSetup();

  const paymentFormSubmitRef = React.useRef<
    (() => Promise<PaymentMethod | undefined>) | undefined
  >(undefined);

  const handleConfirmClick = async () => {
    if (showAddPaymentMethod) {
      const newPaymentMethod = await paymentFormSubmitRef.current?.();
      if (newPaymentMethod) {
        setSelectedPayment(newPaymentMethod);
        setVisible(false);
      }
    }
  };

  return (
    <Modal
      title="Automatic payments"
      isOpen={isVisible}
      onDismiss={() => setVisible(false)}
      buttons={modalButtons}
      size="sm"
    >
      <AutoPayModalContent
        modalType={modalType}
        showAddPaymentMethod={showAddPaymentMethod}
        paymentFormSubmitRef={paymentFormSubmitRef}
        selectedPayment={selectedPayment}
        setSelectedPayment={setSelectedPayment}
        paymentScheduleOptions={scheduleOption}
        setPaymentScheduleOptions={setScheduleOption}
        paymentMethods={paymentMethods}
      />
    </Modal>
  );
};
